module.exports = __webpack_public_path__ + "img/Weapon_11.10e7d923.png";